// timelineService.js
import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getTimelineTasksService = async (projectId, timelineId) => {
  const apiPath = `timelines/project/${projectId}/timeline/${timelineId}/get-timeline-tasks`;

  const signedRequest = await createSignedGetRequest({ apiPath });
  const response = await axios(signedRequest);

  return response.data;
};
